import { api } from "@/api"
import type { ProductTagColor } from "./productTagColors"
import { queryClient } from "@/queryClient"

export type ProductTagIn = {
  label: string
  color: ProductTagColor
  isHidden: boolean
}
export const updateProductTag = async (
  productTagId: string,
  params: ProductTagIn
): Promise<undefined> => {
  await api.put<unknown>(
    `/products/product-tags/${productTagId}/`,
    {
      body: params,
    }
  )
  queryClient.invalidateQueries({
    queryKey: [PRODUCT_TAG_QUERY_KEY],
  })
  return
}
